/**
 * 项目入口文件
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入全局样式
import '@/assets/styles/global.scss'

// 引入懒加载
import VueLazyload from 'vue-lazyload'

// 使用插件
Vue.use(ElementUI)
// 配置懒加载（暂时不设置占位图，后续可添加）
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
